import './emptyBox.scss'

export default {
    name: 'EmptyBox',
    components: {

    },
    props: {
        // 1-暂无数据，2搜索出错
        type: {
            type: Number,
            default: 1
        },
        text: {
            type: String,
            default() {
                return '暂无数据'
            }
        },
        // small,nomal
        size: {
            type: String,
            default() {
                return 'nomal'
            }
        },
        height: {
            type: Number,
            default: 100
        }
    },
    data() {
        return {

        }
    },
    computed: {

    },
    render() {
        return (
            <div class='empty-box' style={`height:${this.height}%`}>
                <div class='con'>
                    <div class={`img ${this.type === 2 ? 'seach-img' : ''} ${this.size === 'small' ? 'img-small' : ''}`} />
                    <div class='text'>{this.text}</div>
                </div>
            </div>
        )
    }
}
